/* BG COM : recherche de l'en-tête (snippets/bgcom-header-search). Sorti du HTML le 03/10/2026, chargé en defer. */
(function () {
  var SECTION = 'bgcom-predictive-search';
  var FIELDS = 'title,product_type,variants.title,variants.sku,vendor';

  /* Shared: refresh the header cart count after any add-to-cart that
     doesn't reload the page (collection cards, quick view, etc.). */
  window.bgcomRefreshCartCount = function () {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('cart-count, .cart-count, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {});
  };

  function init(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';

    var input = root.querySelector('[data-bgcom-hsearch-input]');
    var panel = root.querySelector('[data-bgcom-hsearch-panel]');
    var closeBtn = root.querySelector('[data-bgcom-hsearch-close]');
    if (!input || !panel) return;

    var t, lastQ = '', controller;

    function openSearch() {
      root.hidden = false;
      setToggles(true);
      setTimeout(function () { input.focus(); }, 30);
    }
    function closeSearch() {
      root.hidden = true;
      setToggles(false);
    }
    function setToggles(open) {
      document.querySelectorAll('[data-bgcom-search-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    function applySamita() {
      try {
        document.dispatchEvent(new CustomEvent('page:loaded'));
        if (window.Samita && window.Samita.Wholesale && typeof window.Samita.Wholesale.initialize === 'function') {
          window.Samita.Wholesale.initialize();
        }
      } catch (e) {}
      if (window.bgcomRenderPrices) {
        window.bgcomRenderPrices(panel);
        setTimeout(function () { window.bgcomRenderPrices(panel); }, 350);
        setTimeout(function () { window.bgcomRenderPrices(panel); }, 1000);
      }
    }

    function query(q) {
      if (controller) { try { controller.abort(); } catch (e) {} }
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = '/search/suggest?q=' + encodeURIComponent(q) +
        '&section_id=' + SECTION +
        '&resources[type]=product' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=' + encodeURIComponent(FIELDS);
      panel.innerHTML = '<div class="bgcom-hsearch__loading">Recherche…</div>';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (input.value.trim() !== q) return;
          panel.innerHTML = (html && html.replace(/\s/g, '').length) ? html : '';
          if (panel.innerHTML) applySamita();
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(t);
      if (q.length < 2) { panel.innerHTML = ''; lastQ = ''; return; }
      if (q === lastQ) return;
      lastQ = q;
      t = setTimeout(function () { query(q); }, 170);
    });

    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) closeSearch();
    });

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-bgcom-search-toggle]');
      if (toggle) {
        e.preventDefault();
        if (root.hidden) { openSearch(); } else { closeSearch(); }
        return;
      }
      if (!root.hidden && !root.contains(e.target)) closeSearch();
    });
  }

  function run(scope) { (scope || document).querySelectorAll('[data-bgcom-hsearch]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){ run(); }); }
  else { run(); }
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
